<template>
  <div>
    <header>
      <div class="container">
        <div
          id="head"
          class="head"
        >
          <div class="head-call">
            <img
              src="../assets/images/call.svg"
              alt=""
              @click.prevent="showDropDown = !showDropDown"
              @click="clicked()"
            >
            <div
              v-if="showDropDown"
              class="show-phone"
            >
              <a
                v-for="cont in contact"
                :key="cont.id"
                :href="'tel:' + cont.title"
                v-html="cont.title"
              />
            </div>
          </div>
          <div
            v-if="showDropDown"
            class="call-wrapper"
            @click.prevent="showDropDown = !showDropDown"
          />
          <div class="dropdown-lang d_none">
            <select
              v-model="lang"
              class="dropbtn custom-select"
              @change="handleChange($event)"
            >
              <option
                class="custom-select-opt"
                value="kz"
              >
                KZ
              </option>
              <option
                class="custom-select-opt"
                value="en"
              >
                EN
              </option>
              <option
                class="custom-select-opt"
                value="ru"
              >
                RU
              </option>
            </select>
          </div>
          <div class="head-menu">
            <nav class="navbar navbar-expand-xl navbar-light">
              <div class="container-fluid">
                <button
                  class="navbar-toggler"
                  type="button"
                  data-toggle="collapse"
                  data-target=".navbar-collapse"
                  aria-controls="navbarNav"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span class="navbar-toggler-icon" />
                </button>
                <div
                  id="navbarNav"
                  class="collapse navbar-collapse"
                >
                  <ul class="navbar-nav">
                    <li class="nav-item">
                      <button
                        id="dropdownMenuButton"
                        class="nav-link active btn btn-link dropdown-toggle"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        {{ $t("nav.Bussiness") }}
                      </button>
                      <ul
                        class="nav-link__sub"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <li>
                          <router-link to="/transport">
                            {{ $t("bussiness.transport") }}
                          </router-link>
                        </li>
                        <li>
                          <router-link to="/property-main">
                            {{
                              $t("bussiness.property")
                            }}
                          </router-link>
                        </li>
                        <li>
                          <router-link to="/Cargo">
                            {{
                              $t("bussiness.cargo")
                            }}
                          </router-link>
                        </li>
                        <li>
                          <router-link to="/response">
                            {{ $t("bussiness.response") }}
                          </router-link>
                        </li>
                        <li>
                          <router-link to="/HealthMain">
                            {{
                              $t("bussiness.health")
                            }}
                          </router-link>
                        </li>
                        <li>
                          <router-link to="/TemporaryMain">
                            {{ $t("bussiness.temporary") }}
                          </router-link>
                        </li>
                        <li>
                          <router-link to="/yourBusinessClub">
                            {{ $t("bussiness.yourBusinessClub") }}
                          </router-link>
                        </li>
                      </ul>
                    </li>
                    <li class="nav-item">
                      <button
                        id="dropdownMenuButton1"
                        class="nav-link active btn btn-link dropdown-toggle"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        {{ $t("nav.Individuals") }}
                      </button>
                      <ul
                        id="second-sub"
                        class="nav-link__sub second"
                        aria-labelledby="dropdownMenuButton1"
                      >
                        <li>
                          <router-link to="/autoIndivid">
                            {{ $t("individual.auto") }}
                          </router-link>
                        </li>
                        <li>
                          <router-link to="/healthIndivid">
                            {{
                              $t("individual.health")
                            }}
                          </router-link>
                        </li>
                        <li>
                          <router-link to="/houseIndivid">
                            {{
                              $t("individual.property")
                            }}
                          </router-link>
                        </li>
                        <li>
                          <router-link to="/touristIndivid">
                            {{
                              $t("individual.tourist")
                            }}
                          </router-link>
                        </li>
                        <li>
                          <router-link to="/typeIndivid">
                            {{ $t("individual.type") }}
                          </router-link>
                        </li>
                        <!-- <li>
                          <router-link to="/buisnessIndivid">{{
                            $t("individual.bussiness")
                          }}</router-link>
                        </li> -->
                      </ul>
                    </li>
                    <li class="nav-item">
                      <router-link to="policy">
                        <button
                          id="dropdownMenuButton2"
                          class="nav-link active btn btn-link dropdown-toggle"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          {{ $t("nav.ServicesandPayments1") }}
                        </button>
                      </router-link>
                      <ul
                        class="nav-link__sub"
                        aria-labelledby="dropdownMenuButton2"
                      >
                        <li>
                          <a :href="lang === 'en' ? '/address' : 'https://kupipolis.kz/ru'">{{
                            $t("service.buy")
                          }}</a>
                        </li>
                        <li>
                          <a href="https://id.mkb.kz/#/esbd/checkInsurancePolicy">{{ $t("service.check") }}</a>
                        </li>
                        <li>
                          <a :href="lang === 'en' ? '/address' : 'https://kupipolis.kz/ru/paypartial'">{{
                            $t("service.payment")
                          }}</a>
                        </li>
                        <li>
                          <a href="/carCalculator">{{
                            $t("service.calc")
                          }}</a>
                        </li>
                        <li>
                          <a :href="lang === 'en' ? '/address' : 'https://kupipolis.kz/ru/cabinet/appeal/document/1/'">{{
                            $t("service.online_settlement")
                          }}</a>
                        </li>
                      </ul>
                    </li>
                    <li class="nav-item">
                      <router-link to="/jobAbout">
                        <p class="nav-link">
                          {{ $t("nav.Vacancies") }}
                        </p>
                      </router-link>
                    </li>
                    <li class="nav-item">
                      <!-- <router-link to="/AboutUs">
                                                <p class="nav-link">О компании</p>
                                            </router-link> -->
                      <button
                        id="dropdownMenuButton2"
                        class="nav-link active btn btn-link dropdown-toggle"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        {{ $t("nav.AboutUs") }}
                      </button>
                      <ul class="nav-link__sub">
                        <li>
                          <router-link to="/about">
                            {{
                              $t("about.AboutUs")
                            }}
                          </router-link>
                        </li>
                        <li>
                          <router-link to="/documentsAbout">
                            {{
                              $t("about.doc")
                            }}
                          </router-link>
                        </li>
                        <li>
                          <router-link to="/pressAbout">
                            {{
                              $t("about.press")
                            }}
                          </router-link>
                        </li>
                        <li>
                          <router-link to="/compliance">
                            {{
                              $t("about.compl")
                            }}
                          </router-link>
                        </li>
                        <!-- <li>
                          <router-link to="/jobAbout">{{
                            $t("about.vac")
                            }}</router-link>
                        </li> -->
                        <li>
                          <router-link to="/Address">
                            {{
                              $t("about.address")
                            }}
                          </router-link>
                        </li>
                        <li>
                          <router-link to="/reception-hours">
                            {{
                              $t("about.reception")
                            }}
                          </router-link>
                        </li>
                        <li>
                          <router-link to="/eventAbout">
                            {{
                              $t("about.event")
                            }}
                          </router-link>
                        </li>
                        <li>
                          <router-link to="/HolderAbout">
                            {{
                              $t("about.ac")
                            }}
                          </router-link>
                        </li>
                        <li>
                          <router-link to="/digitalAbout">
                            {{
                              $t("about.dig")
                            }}
                          </router-link>
                        </li>
                      </ul>
                    </li>
                    <li class="nav-item">
                      <router-link to="/finance-literacy">
                        <p class="nav-link">
                          {{ $t("nav.FinanceLiteracy") }}
                        </p>
                      </router-link>
                    </li>
                    <li class="nav-item">
                      <button
                        id="dropdownMenuButton2"
                        class="nav-link active btn btn-link dropdown-toggle"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        {{ $t("nav.Contacts") }}
                      </button>
                      <ul
                        class="nav-link__sub"
                        aria-labelledby="dropdownMenuButton2"
                      >
                        <li>
                          <a
                            v-for="cont in contact"
                            :key="cont.id"
                            :href="'tel:' + cont.title"
                            v-html="cont.title"
                          />
                        </li>
                      </ul>
                    </li>
                    <!-- <li class="nav-item">
                      <router-link to="/Address">
                        <p class="nav-link">{{ $t("nav.Address") }}</p>
                      </router-link>
                    </li> -->
                    <li class="nav-item">
                      <button
                        id="dropdownMenuButtonAccount"
                        class="nav-link active btn btn-link dropdown-toggle"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        {{ $t("nav.Personal_account") }}
                      </button>
                      <ul
                        class="nav-link__sub"
                        aria-labelledby="dropdownMenuButtonAccount"
                      >
                        <li>
                          <a @click="openModal">
                            {{ $t("nav.Personal_account") }}
                          </a>
                        </li>
                        <li v-if="user">
                          <a @click="openNotificationsModal">
                            {{ $t("nav.Notifications") }}
                            <template v-if="notifications.length > 0">({{ notifications.length }})</template>
                          </a>
                        </li>
                        <li v-if="user">
                          <a @click="openDocumentModal">
                            {{ $t("nav.Documents") }}
                          </a>
                        </li>
                        <li v-if="user">
                          <a @click="logout">
                            {{ $t("nav.Logout") }}
                          </a>
                        </li>
                      </ul>
                    </li>
                    <li class="nav-item">
                      <button
                        class="nav-link active btn btn-link"
                        type="button"
                        onclick="letsee_toggle_panel()"
                      >
                        Версия для слабовидящих
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </nav>
          </div>
          <div class="head-left">
            <h5
              class="head-left-est m_none"
              :style="{ fontSize: fontSize + 'px' }"
            >
              Est. 1997
            </h5>
            <router-link to="/">
              <img
                src="../assets/images/logo.svg"
                alt=""
                class="head-left-logo"
              >
            </router-link>
          </div>
          <div class="dropdown">
            <router-link to="/transport">
              <button
                class="dropbtn active"
                name=""
              >
                {{ $t("nav.Bussiness") }}
              </button>
            </router-link>
            <div class="dropdown-content">
              <router-link to="/transport">
                {{
                  $t("bussiness.transport")
                }}
              </router-link>
              <router-link to="/property-main">
                {{
                  $t("bussiness.property")
                }}
              </router-link>
              <router-link to="/Cargo">
                {{ $t("bussiness.cargo") }}
              </router-link>
              <router-link to="/response">
                {{
                  $t("bussiness.response")
                }}
              </router-link>
              <router-link to="/HealthMain">
                {{
                  $t("bussiness.health")
                }}
              </router-link>
              <router-link to="/TemporaryMain">
                {{
                  $t("bussiness.temporary")
                }}
              </router-link>
              <router-link to="/yourBusinessClub">
                {{
                  $t("bussiness.yourBusinessClub")
                }}
              </router-link>
            </div>
          </div>
          <div class="dropdown">
            <router-link to="/autoIndivid">
              <button class="dropbtn">
                {{ $t("nav.Individuals") }}
              </button>
            </router-link>
            <div class="dropdown-content">
              <router-link to="/autoIndivid">
                {{
                  $t("individual.auto")
                }}
              </router-link>
              <router-link to="/healthIndivid">
                {{
                  $t("individual.health")
                }}
              </router-link>
              <router-link to="/houseIndivid">
                {{
                  $t("individual.property")
                }}
              </router-link>
              <router-link to="/touristIndivid">
                {{
                  $t("individual.tourist")
                }}
              </router-link>
              <router-link to="/typeIndivid">
                {{
                  $t("individual.type")
                }}
              </router-link>
              <!-- <router-link to="/buisnessIndivid">{{
                $t("individual.bussiness")
              }}</router-link> -->
            </div>
          </div>
          <div class="dropdown">
            <router-link to="/policy">
              <button class="dropbtn">
                {{ $t("nav.ServicesandPayments") }}
              </button>
            </router-link>
            <div class="dropdown-content">
              <a :href="lang === 'en' ? '/address' : 'https://kupipolis.kz/ru'">{{ $t("service.buy") }}</a>
              <a href="https://id.mkb.kz/#/esbd/checkInsurancePolicy">{{
                $t("service.check")
              }}</a>
              <a :href="lang === 'en' ? '/address' : 'https://kupipolis.kz/ru/paypartial'">{{
                $t("service.payment")
              }}</a>
              <a href="/carCalculator">{{ $t("service.calc") }}</a>
              <a :href="lang === 'en' ? '/address' : 'https://kupipolis.kz/ru/cabinet/appeal/document/1/'">{{ $t("service.online_settlement") }}</a>
            </div>
          </div>
          <div class="dropdown">
            <router-link to="/about">
              <button class="dropbtn">
                {{ $t("nav.AboutUs") }}
              </button>
            </router-link>
            <div class="change-width">
              <div class="dropdown-content">
                <router-link to="/about">
                  {{
                    $t("about.AboutUs")
                  }}
                </router-link>  
                <router-link to="/documentsAbout">
                  {{
                    $t("about.doc")
                  }}
                </router-link>
                <router-link to="/pressAbout">
                  {{
                    $t("about.press")
                  }}
                </router-link>
                <router-link to="/compliance">
                  {{
                    $t("about.compl")
                  }}
                </router-link>
                <!-- <router-link to="/jobAbout">{{ $t("about.vac") }}</router-link> -->
                <router-link to="/address">
                  {{ $t("about.address") }}
                </router-link>
                <router-link to="/reception-hours">
                  {{ $t("about.reception") }}
                </router-link>
                <router-link to="/eventAbout">
                  {{
                    $t("about.event")
                  }}
                </router-link>
                <router-link to="/HolderAbout">
                  {{
                    $t("about.ac")
                  }}
                </router-link>
                <router-link to="/digitalAbout">
                  {{
                    $t("about.dig")
                  }}
                </router-link>
              </div>
            </div>
          </div>
          <div class="dropdown">
            <router-link to="/finance-literacy">
              <button class="dropbtn dropbtn-two-lines">
                {{ $t("nav.FinanceLiteracy") }}
              </button>
            </router-link>
          </div>
          <div class="dropdown">
            <router-link to="/jobAbout">
              <button class="dropbtn-change1">
                {{ $t("nav.Vacancies") }}
              </button>
            </router-link>
          </div>
          <div class="dropdown">
            <button class="dropbtn-change">
              {{ $t("nav.Contacts") }}
            </button>
            <div class="dropdown-content">
              <a
                v-for="cont in contact"
                :key="cont.id"
                :href="'tel:' + cont.title"
                v-html="cont.title"
              />
            </div>
          </div>
          <!-- <div class="dropdown">
            <router-link to="/Address"><button class="dropbtn-change1">
                {{ $t("nav.Address") }}
              </button></router-link>
          </div> -->
          <div class="dropdown-desktop">
            <select
              v-model="lang"
              class="dropbtn custom-select"
              style="border: none"
              @change="handleChange($event)"
            >
              <option
                class="custom-select-opt"
                value="kz"
              >
                KZ
              </option>
              <option
                class="custom-select-opt"
                value="en"
              >
                EN
              </option>
              <option
                class="custom-select-opt"
                value="ru"
              >
                RU
              </option>
            </select>
          </div>
          <!-- <div class="home">
                        <a href="/"><img src="../assets/images/home.svg" alt=""></a>
                    </div> -->
          <button class="head-glasses" onclick="letsee_toggle_panel()">
            <!-- <a href="javascript://" onclick="letsee_toggle_panel()">Версия для слабовидящих</a> -->
              <img
                class="glass"
                src="../assets/images/glasses-header.svg"
                alt=""
              >
            <!-- <img class="glass" src="../assets/images/glasses.svg" alt=""> -->
          </button>
          <div class="dropdown">
            <button class="account_btn">
              <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M16 5.5C16 5.23478 15.8946 4.98043 15.7071 4.79289C15.5196 4.60536 15.2652 4.5 15 4.5H4.692C4.42678 4.5 4.17243 4.60536 3.98489 4.79289C3.79736 4.98043 3.692 5.23478 3.692 5.5C3.692 5.76522 3.79736 6.01957 3.98489 6.20711C4.17243 6.39464 4.42678 6.5 4.692 6.5H15C15.2652 6.5 15.5196 6.39464 15.7071 6.20711C15.8946 6.01957 16 5.76522 16 5.5ZM16 1.5C16 1.23478 15.8946 0.98043 15.7071 0.792893C15.5196 0.605357 15.2652 0.5 15 0.5H1C0.734783 0.5 0.480429 0.605357 0.292892 0.792893C0.105356 0.98043 0 1.23478 0 1.5C0 1.76522 0.105356 2.01957 0.292892 2.20711C0.480429 2.39464 0.734783 2.5 1 2.5H15C15.2652 2.5 15.5196 2.39464 15.7071 2.20711C15.8946 2.01957 16 1.76522 16 1.5ZM16 9.5C16 9.23478 15.8946 8.98043 15.7071 8.79289C15.5196 8.60536 15.2652 8.5 15 8.5H1C0.734783 8.5 0.480429 8.60536 0.292892 8.79289C0.105356 8.98043 0 9.23478 0 9.5C0 9.76522 0.105356 10.0196 0.292892 10.2071C0.480429 10.3946 0.734783 10.5 1 10.5H15C15.2652 10.5 15.5196 10.3946 15.7071 10.2071C15.8946 10.0196 16 9.76522 16 9.5ZM16 13.5C16 13.2348 15.8946 12.9804 15.7071 12.7929C15.5196 12.6054 15.2652 12.5 15 12.5H4.692C4.42678 12.5 4.17243 12.6054 3.98489 12.7929C3.79736 12.9804 3.692 13.2348 3.692 13.5C3.692 13.7652 3.79736 14.0196 3.98489 14.2071C4.17243 14.3946 4.42678 14.5 4.692 14.5H15C15.2652 14.5 15.5196 14.3946 15.7071 14.2071C15.8946 14.0196 16 13.7652 16 13.5Z" fill="black"/>
              </svg>

              <p v-if="notifications.length > 0 && user" class="account_btn_notification">{{ notifications.length }}</p>
            </button>
            <div class="dropdown-content account_dropdown_content">
              <div class="account_dropdown_content_item" @click="openModal">
                <img src="@/assets/images/user_icon.svg" alt="">
                <a>{{ $t("nav.Personal_account") }}</a>
              </div>
              <div v-if="user" class="account_dropdown_content_item" @click="openNotificationsModal">
                <img src="@/assets/images/notification_icon.png" alt="">
                <a>{{ $t("nav.Notifications") }}</a>
                <p v-if="notifications.length > 0" class="account_btn_notification">{{ notifications.length }}</p>
              </div>
              <div v-if="user" class="account_dropdown_content_item" @click="openDocumentModal">
                <img src="@/assets/images/documents_icon.svg" alt="">
                <a>{{ $t("nav.Documents") }}</a>
              </div>
              <div v-if="user" class="account_dropdown_content_item" @click="logout">
                <img src="@/assets/images/exit_icon.svg" alt="">
                <a>{{ $t("nav.Logout") }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  </div>
  <LoginModal :open="isOpen" @close="isOpen = !isOpen"/>
  <PersonalNotificationModal :open="isNotificationsModalOpen" :notifications="notifications" @close="isNotificationsModalOpen = false" @readAllNotifications="readAllNotifications"/>
  <DocumentModal :open="isDocumentModalOpen" :documents="documents" @close="isDocumentModalOpen = false" />
</template>

<script>
import axios from "axios";
import LoginModal from "./LoginModal.vue";
import PersonalNotificationModal from "../views/PersonalNotificationModal.vue";
import DocumentModal from "../views/DocumentModal.vue";
import router from "@/router";
import store from '@/store'
import {ref, computed} from 'vue'
export default {
  components: {LoginModal, PersonalNotificationModal, DocumentModal},
  setup() {
    const isOpen = ref(false)
    return {isOpen}
  },
  data: function () {
    const lang = localStorage.getItem("lang") || "ru";
    const user = computed(() => store.getters['auth/getUser'])
    
    return {
      isNotificationsModalOpen: false,
      notifications: [],
      lang: lang,
      fontSize: 14,
      contact: [],
      showDropDown: false,
      user,
      documents: [],
      isDocumentModalOpen: false,
    };
  },
  created() {
    if(this.user){
      axios.get(`/V1/notifications`).then(res => {
        this.notifications = res.data.data.notifications
      })
      // this.contacts();
      this.fetchDocuments();
    }
  },
  watch: {
    user(newUser, oldUser) {
        if (newUser && !oldUser) {
          // Fetch notifications and documents after login
          this.getNotifications();
          this.fetchDocuments();
        }
    },
    isOpen: function() {
      if(this.isOpen){
        document.documentElement.style.overflow = 'hidden'
        return
      }
        document.documentElement.style.overflow = 'auto'
      }
    },
  methods: {
    openDocumentModal() {
        this.isDocumentModalOpen = true;
    },
    fetchDocuments() {
        axios.get('/V1/files')
            .then(response => {
                this.documents = response.data.data.files
            })
            .catch(error => {
                console.error("There was an error fetching the documents:", error);
                if (error.response && error.response.status === 401) {
                    // Token is invalid, let the interceptor handle logout
                    console.log("Unauthorized access to documents");
                }
                this.documents = [];
            });
    },
    getNotifications() {
        if (this.user) {
            axios.get(`/V1/notifications`).then(res => {
                this.notifications = res.data.data.notifications;
            }).catch(error => {
                console.error("Error fetching notifications:", error);
                if (error.response && error.response.status === 401) {
                    // Token is invalid, let the interceptor handle logout
                    console.log("Unauthorized access to notifications");
                }
                this.notifications = [];
            });
        }
    },
    openNotificationsModal(){
      this.isNotificationsModalOpen = true
    },
    readAllNotifications(){
      axios.put(`/V1/notifications/read`).then(res => {
        this.notifications = []
      })
      this.isNotificationsModalOpen = false
    },
    openModal(){
      if(store.getters['auth/getUser']){
        router.push('/profile')
      }else{
        this.isOpen = true
      }
    },
    handleChange(event) {
      localStorage.setItem("lang", event.target.value);
      window.location.reload();
    },
    contacts() {
      axios
        .get("V1/contacts")
        .then((response) => {
          this.contact = response.data.data;
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    clicked() {
      setTimeout(()=> (this.showDropDown = false), 3000)
    },
    async logout(){
      await store.dispatch('auth/logout')
      router.push('/')
    }
  },
};
</script>

<style lang="scss" scoped>
.dropdown-toggle::after {
  content: none;
}

@mixin fontStyle($family, $style, $weight, $size, $lheight, $color) {
  font-family: $family;
  font-style: normal;
  font-weight: $weight;
  font-size: $size;
  line-height: $lheight;
  color: $color;
}

@import url("https://fonts.googleapis.com/icon?family=Material+Icons");

@mixin mobile {
  @media (min-width: 320px) and (max-width: 424px) {
    @content;
  }
}

@mixin tablet {
  @media (min-width: 425px) and (max-width: 1040px) {
    @content;
  }
}

@mixin tablet-1024 {
  @media (min-width: 768px) and (max-width: 1024px) {
    @content;
  }
}

@mixin desktop {
  @media (min-width: 1024px) and (max-width: 1440px) {
    @content;
  }
}

@mixin desktop-max {
  @media (min-width: 1440px) {
    @content;
  }
}
.show-phone {
  position: absolute;
  font-size: 12px;
  line-height: 14px;
  // margin-left: -20%;
  background: #ffffff;
  border: 1px solid #acacac;
  border-radius: 5px;
  padding: 5px;
  a {
    color: #373737;
    font-weight: normal;
  }
  @include tablet() {
    // margin-left: -80px;
  }
}
.navbar-collapse {
  // background: linear-gradient(90deg, #DEDEDE 42%, #EFEFEF 40%);
  //changes
  // background: linear-gradient(90deg, #DEDEDE 35%, #EFEFEF 33%);
  background: #efefef;
  margin-top: 20px;
  bottom: 0;
  // @include tablet() {
  //     background: linear-gradient(90deg, #DEDEDE 38%, #EFEFEF 33%);
  // }
}

.account_btn:hover .menu-text {
  color: #007BFF;
  margin: 0;
}

.account_btn:hover path {
  fill: #007BFF;
}

.letsee-link {
  display: flex;
  justify-content: center;
  align-items: center;
}

.container {
  padding-left: 0;
  padding-right: 0;
}
.dropdown-lang {
  z-index: 6;
  // margin-left: -25%;
  // margin-top: -5%;
  .custom-select {
    width: auto;
    border: none;
    @include fontStyle(Roboto, normal, 400, 14px, 14px, #373737);
    background: url("../assets/images/arrow-menu.png");
    background-repeat: no-repeat;
    background-position: right;
    padding-left: 0.75rem;
    padding-bottom: 6px;
    padding-right: 13px;
    &:focus {
      border: none;
    }
    &-opt {
      @include fontStyle(Roboto, normal, 400, 14px, 14px, #373737);
    }
  }
}
.account_btn{
  padding: 7px 17px;
  border: none;
  background: #F1F1F1;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
	height: 37px;
  &_notification{
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background: #007BFF;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    font-size: 13px;
  }
}
.call-wrapper {
  left: 0;
  bottom: 0;
  position: absolute;
  width: 100%;
  height: 100%;
}
.home {
  img {
    // width: 19px;
    margin-left: 5px;
    margin-right: 5px;
  }
  @include tablet-1024() {
    img {
      width: 19px;
    }
  }
  @include desktop() {
    img {
      width: 19px;
    }
  }
  @include mobile() {
    display: none;
  }
  @include tablet() {
    display: none;
  }
}
.account_dropdown_content{
  width: clamp(200px, 118%, 420px) !important;
  &_item{
    display: flex;
    gap: 5px;
    align-items: center;
    padding: 7px 0
  }
}
.head {
  margin-top: 20px;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  &-glasses {

    background-color: #F1F1F1;
    border-radius: 8px;

    padding: 12px 15px;
    border: none;
    cursor: pointer;
    margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
		@media (max-width: 1040px) {
			display: none;
		}

    &:hover {
      img {
        transform: scale(1.5);
      }
    }

    img {
      transition: all 0.5s;
    }
  }
  @include tablet-1024() {
    &-glasses {
      img {
        width: 20px;
      }
    }
  }
  &-menu {
    display: none;
    width: 30%;

    * html ul li {
      float: left;
    }

    * html ul li a {
      height: 1%;
    }
    .nav-link {
      @include fontStyle(Roboto, normal, 300, 14px, 16px, #959595);
      color: #959595 !important;
      padding-left: 20px;
      .active {
        color: #373737 !important;
        font-weight: 400;
      }
      &__sub {
        padding-left: 80px;
        @include fontStyle(Roboto, normal, 300, 12px, 14px, #959595);
        // top: 0;
        .second {
          top: -30px !important;
        }
      }
      &:hover {
        font-weight: 500;
        color: #373737 !important;
        transition: all 0.6s;
      }
      @media (max-width: 360px) {
        padding-left: 3% !important;
      }
      @include mobile() {
        //changes
        font-size: 12px !important;
        line-height: 14px;
        color: #373737 !important;
        font-weight: 600;
        margin-bottom: 0;
        padding-left: 8%;
        p {
          margin-bottom: 0;
        }
        &__sub {
          font-size: 10px;
          line-height: 20px;
          color: #373737;
          text-transform: uppercase;
          width: 175px;
          padding-left: 14px;
          // margin: 0 auto;
        }
        &:hover,
        &:focus {
          font-weight: 500;
          color: #373737 !important;
          background-color: #fff;
          width: 100%;
          border-radius: 0px;
          text-align: inherit;
          transition: all 0.6s;
        }
      }
      @include tablet() {
        font-size: 13px !important;
        line-height: 17px;
        color: #373737 !important;
        font-weight: 600;
        margin-bottom: 0;
        padding-left: 8%;
        p {
          margin-bottom: 0;
        }
        &__sub {
          font-size: 12px;
          line-height: 20px;
          color: #373737;
          text-transform: uppercase;
          width: 275px;
          padding-left: 14px;
          // margin: 0 auto;
        }
        &:hover,
        &:focus {
          font-weight: 500;
          color: #373737 !important;
          background-color: #fff;
          width: 100%;
          border-radius: 0px;
          text-align: inherit;
          transition: all 0.6s;
        }
      }
    }

    ul {
      // border-bottom: 1px solid #000;
      list-style: none;
      margin: 0;
      padding: 0;
      width: 100%;
      height: 100vh;
      position: relative;
      @include tablet() {
        height: 110vh;
      }
      li {
        background: #dedede;
        width: 164px;
        @include tablet() {
          width: 194px;
        }
        &:last-child {
          height: 100vh;
        }
        a {
          display: block;
          // border: 1px solid #000;
          border-bottom: 1px;
          padding: 5px 0px;
          text-decoration: none;
          color: #373737 !important;
          font-weight: 400;
        }

        :hover ul {
          display: block;
          transition: all 0.6s;
          // top: -30px;
        }
        // :hover .nav-link__sub .second {
        //     top: -30px !important;
        // }
        ul {
          display: none;
          left: 137px;
          // left: 99px;
          position: absolute;
          top: 0px;
          background-color: #efefef;
          li {
            background-color: #efefef;
            padding-top: 10px;
            @include tablet() {
              padding-top: 15px;
            }
          }
        }
      }
    }

    li:hover ul {
      display: block;
    }

    .navbar {
      z-index: 5;
      padding: 0;
      &-light,
      &-toggler {
        border: none;
        @include tablet() {
          // padding-right: 3%;
        }
      }

      &-expand-xl {
        .container-fluid {
          padding-top: 20px;
          flex-direction: row-reverse;
          @include tablet() {
            width: 100%;
            margin: 0 auto;
          }
        }
      }
    }
  }

  &-left {
    z-index: 111;

    &-est {
      @include fontStyle(Roboto, normal, 300, 14px, 136.69%, #000000);
      background: linear-gradient(
        90deg,
        #ff143f 0%,
        #c600dd 49.97%,
        #1b27ff 100%
      );
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }

    &-logo {
      // max-width: 90px;
      width: 150px;
			@media (max-width: 1350px) {
				width: 110px;
			}
    }
  }

  &-call {
    display: none;
  }

  .dropdown {
    position: relative;
    display: inline-block;
    padding-top: 20px;
    &:hover {
      .dropdown-content {
        display: block;
        z-index: 223;
        cursor: pointer;
      }

      .dropbtn {
        transition: 0.4s;
        background-color: #f1f1f1;
        // width: 192px;
      }
    }

    .dropbtn {
      @include fontStyle(Roboto, normal, 400, 16px, 136.69%, #373737);
      background-color: #ffffff;
      text-transform: uppercase;
      padding: 10px;
      border: none;
      &-change {
        text-transform: none;
        @include fontStyle(Roboto, normal, 400, 16px, 136.69%, #373737);
        background-color: #ffffff;
        padding: 13px;
        border: none;
        background: url("../assets/images/arrow-menu.png");
        background-repeat: no-repeat;
        background-position: right;
				@media (max-width: 1350px) {
					font-size: 14px;
					padding: 6px;
				}
        &:hover {
          background-color: #f1f1f1;
          transition: all 0.6s;
        }
      }
      &-two-lines {
        width: min-content;
        padding-top: 0;
        padding-bottom: 0;
      }
      @media (min-width: 1041px) and (max-width: 1200px) {
        &,
        &-change,
        &-change1 {
          font-size: 11px !important;
          padding: 4px !important;
        }
      }
      &-change1 {
        text-transform: none;
        @include fontStyle(Roboto, normal, 400, 16px, 136.69%, #373737);
        background-color: #ffffff;
        padding: 13px;
        border: none;
				@media (max-width: 1350px) {
					font-size: 14px;
					padding: 6px;
				}
        &:hover {
          background-color: #f1f1f1;
          transition: all 0.6s;
          box-shadow: -5px 0px 0px 0px #f1f1f1, 5px 0px 0px 0px #f1f1f1;
        }
      }
      .custom-select {
        :focus {
          box-shadow: none;
        }
      }
      option {
        @include fontStyle(Roboto, normal, 400, 14px, 14px, #373737);
      }

      &:focus {
        color: #000000;
      }
    }

    &-content {
      display: none;
      position: absolute;
      background-color: #ffffff;
      border: 1px solid #f1f1f1;
      width: clamp(200px, 118%, 420px);
      box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
      z-index: 1;
      border-radius: 5px;
      a {
        &:hover {
          color: #007BFF;
          text-decoration: underline;
          background-color: #ffffff !important;
          transition: all 0.3s;
        }
      }
      &::before {
        position: absolute;
        content: "";
        height: 10px;
        width: 10px;
        background: #ffffff;
        left: 20px;
        top: -5px;
        transform: rotate(45deg);
      }

      a {
        @include fontStyle(Roboto, normal, 300, 16px, 18px, #373737);
        padding: 6px 4px;
        text-decoration: none;
        display: block;

        &:hover {
          background-color: #ddd;
        }
      }
    }

    .active {
      color: #000000;
      font-weight: 400;
    }

    &-desktop {
      padding-top: 15px;
      .custom-select {
        width: auto;
        // border: none;
        @include fontStyle(Roboto, normal, 300, 18px, 21px, #373737);
        background: url("../assets/images/arrow-menu.png");
        background-repeat: no-repeat;
        background-position: right center;
        padding-left: 0.75rem;
        padding-bottom: 0;
        padding-right: 13px;
				@media (max-width: 1350px) {
					font-size: 14px;
				}
        option {
          @include fontStyle(Roboto, normal, 300, 14px, 14px, #373737);
          width: 200px;
        }
        @include tablet-1024() {
          font-size: 11px;
        }
        &:hover {
          background-color: #f1f1f1;
          // outline: 1px solid #f1f1f1;
          // height: 30px;
          // outline-width: 30px;
          
          box-shadow: -2px 0px 0px 0px #f1f1f1, 5px 0px 0px 0px #f1f1f1;
          // outline-width: 100px;
          height: 45px;
          transition: all 0.6s;
        }
        &:focus,
        &:focus-visible {
          border: none !important;
          outline: none !important;
        }
      }
    }
  }

  @include mobile() {
    &-left {
      width: 43%;
      margin: 0 auto;
      text-align: center;
      margin-left: -23%;
      &-logo {
        min-width: 79px;
        max-width: 96px;
      }
      &-est {
        font-size: 10px !important;
      }
    }
    &-call {
      display: inline-block;
      z-index: 111;
    }

    .d-none {
      display: inline !important;
    }

    &-menu {
      .navbar {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        background: #ffffff;
        padding: 0;
        // background: linear-gradient(90deg, #FFC0CB 50%, #00FFFF 50%);
      }
      ul {
        li {
          a {
            padding: 0;
            color: #595959;
            &:active {
              color: linear-gradient(
                90deg,
                #ff143f 0%,
                #c600dd 49.97%,
                #1b27ff 100%
              );
            }
          }
        }
      }
    }

    .dropdown {
      display: none;
      &-desktop {
        display: none;
      }
      &-lang {
        .custom-select {
          padding-bottom: 2px;
          padding-right: 13px;
          margin-right: 6px;
        }
      }
    }

    &-menu {
      display: block;
    }

    &-glasses {
      .glass {
        display: none;
      }

      a {
        display: block;
      }
    }
  }

  @include tablet() {
    &-left {
      width: 42%;
      margin-left: -14% !important;
      margin: 0 auto;
      text-align: center;
      &-logo {
        min-width: 79px;
        max-width: 136px;
      }

      &-est {
        font-size: 10px;
      }
    }

    &-call {
      display: inline-block;
      z-index: 111;
      // position: absolute;
      // right: 0;
      width: 6%;
      padding-bottom: 10px;
      // margin-right: -10px;
    }

    &-menu {
      display: block;
      ul {
        li {
          a {
            padding: 0;
          }
        }
      }

      .navbar {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        background: #ffffff;
      }
    }

    .dropdown {
      display: none;

      &-desktop {
        display: none;
      }
      &-lang {
        padding-bottom: 8px;
        .custom-select {
          margin-right: 10px;
        }
      }
    }

    &-glasses {
      .glass {
        display: none;
      }

      a {
        display: block;
      }
    }
  }

  @include tablet-1024() {
    .dropdown {
      .dropbtn,
      .dropbtn-change,
      .dropbtn-change1 {
        font-size: 8px;
      }

      &-content {
        a {
          font-size: 9px;
        }
      }
    }
    &-left {
      &-logo {
        width: 75px;
      }
      &-est {
        font-size: 10px !important;
      }
    }
  }

  @include desktop() {
    &-left {
    }
    .dropdown {
      .dropbtn {
        font-size: 14px;
				@media (max-width: 1350px) {
					font-size: 12px;
					padding: 6px;
				}
      }

      &-content {
        a {
          font-size: 12px;
        }
      }
    }
  }

  @include desktop-max() {
    .dropdown {
      .dropbtn {
        font-size: 14px;
				@media (max-width: 1350px) {
					font-size: 12px;
					padding: 6px;
				}
        line-height: 22px;
        font-weight: 400;
      }

      &-content {
        width: clamp(283px, 140%, 430px);
        padding: 5px;
        a {
          font-size: 14px;
        }
      }
    }
  }

  .d-none {
    display: none;
  }
}
</style>
